export const MODULE_NAME = 'vehicles'
export const VEHICLES = 'VEHICLES'
export const VEHICLE = 'VEHICLE'
export const SET_VEHICLES = 'SET_VEHICLES'
export const SET_VEHICLE = 'SET_VEHICLE'
export const KEY_STORE = 'VEHICLE_JOURNEY'
export const KEY = 'vehicles'
